/*
  When users switch which business they are logged into we need to clear some context
  in the browser so that it doesn't cross-contaminate. This is all local storage for now,
  but it may include cookies or other values in the future.
*/

function mergeLocalStorageJSON(key: string, updates: Record<string, unknown>) {
	const existingValue = localStorage.getItem(key);

	if (existingValue === null) return;

	const parsed = JSON.parse(existingValue);

	localStorage.setItem(
		key,
		JSON.stringify({
			...parsed,
			...updates,
		})
	);
}

const localStorageKeysToClear = [
	'dashboard.branchIds',
	'dashboard.openedJobIds',
	'jobIndex.assigneesFilter',
	'jobIndex.phasesFilter',
	'submittalContactIds',
];

export default function switchBusiness() {
	localStorageKeysToClear.forEach((key) => {
		localStorage.removeItem(key);
	});

	// More complicated changes
	mergeLocalStorageJSON('schedulingViewConfig', {
		filteredBranchIds: [],
		filteredUserGroupId: undefined,
		filteredUserIds: [],
	});

	mergeLocalStorageJSON('timeTrackingViewConfig', {
		userIds: [],
	});
}
